import { Link } from "react-router-dom";
import { PINNED_PRODUCT_ID } from "@/utils/collections";

// Banner da página inicial: leva ao produto fixado (Kit Empreendedor). A imagem
// aparece inteira (proporção 3:1); no celular usa um recorte da parte do texto, pra
// continuar legível em tela estreita.
export default function CategoryHero() {
  const base = import.meta.env.BASE_URL;
  return (
    <Link to={`/produto/${PINNED_PRODUCT_ID}`} className="home-banner" aria-label="Garanta já seu Kit Empreendedor e comece a lucrar agora mesmo">
      <picture>
        <source media="(max-width: 767px)" srcSet={`${base}banner-kit-empreendedor-mobile.webp`} width={1080} height={667} />
        <img
          src={`${base}banner-kit-empreendedor.webp`}
          alt="Kit Empreendedor: bandejas com brincos dourados e coloridos. Garanta já seu kit e comece a lucrar agora mesmo!"
          width={2000}
          height={667}
          fetchPriority="high"
        />
      </picture>
    </Link>
  );
}
